import React, { ReactElement } from 'react';
import FilterPrice from '../filter-price/filter-price';
import FilterGroup from '../filter-group/filter-group';
import FilterEntrySearch from '../filter-entry-search';
import { useSeo } from 'hooks/use-seo';
import { Filters } from 'modules/shared/modules/categories-shared/interfaces/category-full.interface';
import { FiltersActions } from 'modules/producers/reducers/producer-url-params.reducer';
import { useProducerUrlType } from 'modules/producers/hooks/use-producer-url';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { useCategoryUrlType } from 'modules/categories/interfaces/use-category-url.type';

import './filters-groups.scss';

const FiltersGroups: React.FC<{
    filters: Filters;
    getUrl: useCategoryUrlType | useProducerUrlType;
    showPriceFilter?: boolean;
    filtersActions: typeof FiltersActions;
    limit?: number;
}> = ({
    filters,
    getUrl,
    showPriceFilter = true,
    filtersActions,
    limit
}): ReactElement => {
    const seo = useSeo();
    const selectedTotal = filters.groups.reduce((total, group) => total + group.selected, 0);
    const limitReached = limit !== void 0 && selectedTotal >= limit;

    return (
        <>
            {limitReached && (
                <p className="filters-groups__limit-info">
                    Wybrano maksymalną liczbę filtrów ({limit}). Odznacz jeden, aby wybrać inny.
                </p>
            )}
            {showPriceFilter && (
                <FilterGroup
                    key="Cena"
                    name="Cena"
                    position={0}
                    selected={0}
                    open={true}
                >
                    <FilterPrice />
                </FilterGroup>
            )}
            { filters.groups.map((group, idx) => (
                <FilterGroup
                    key={group.name}
                    pk={group.pk}
                    name={group.name}
                    position={group.position}
                    description={group.description || ''}
                    operator={group.operator}
                    selected={group.selected}
                    open={(idx + 1) < 4 || group.selected > 0}
                >
                    <FilterEntrySearch
                        entries={group.entries}
                        rel={group.selected !== 0 ? SeoLinkRelEnum.NOFOLLOW : seo.rel}
                        getUrl={getUrl}
                        filtersActions={filtersActions}
                        limitReached={limitReached}
                    />
                </FilterGroup>
            ))}
        </>
    );
};

export default FiltersGroups;
